import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LeadThanks: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    const timer = window.setTimeout(() => {
      navigate('/student-pathway');
    }, 6000);

    return () => window.clearTimeout(timer);
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center bg-white/5 border border-white/10 rounded-3xl p-8 shadow-2xl">
        <p className="text-xs uppercase tracking-[0.3em] text-emerald-200">Thank You</p>
        <h1 className="text-3xl font-semibold mt-3">Thanks for sharing your info.</h1>
        <p className="text-white/70 mt-4 text-base">
          We’ll set up your pipeline profile so you can view program details and track your next steps.
        </p>
        <button
          onClick={() => navigate('/student-pathway')}
          className="mt-6 inline-flex items-center justify-center px-6 py-3 rounded-xl bg-emerald-600 text-white font-semibold hover:bg-emerald-500 transition"
        >
          Continue to Step 1
        </button>
        <p className="text-white/50 text-sm mt-3">Redirecting you now…</p>
      </div>
    </div>
  );
};

export default LeadThanks;
